import React, { type PropsWithChildren } from 'react';

export function Head(props: PropsWithChildren) {
  return null;
}

Head.Provider = React.Fragment;
